import { create } from 'zustand';
import type { DeviceListResponseDto, DeviceStatusResponseDto } from '@laxmi-ai/shared';

interface DeviceStoreState {
  devices: DeviceListResponseDto | null;
  selectedDeviceSerial: string | null;
  deviceStatus: Record<string, DeviceStatusResponseDto>;
  isLoading: boolean;
  error: string | null;
  setDevices: (devices: DeviceListResponseDto) => void;
  setSelectedDevice: (serial: string | null) => void;
  setDeviceStatus: (serial: string, status: DeviceStatusResponseDto) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useDeviceStore = create<DeviceStoreState>((set) => ({
  devices: null,
  selectedDeviceSerial: null,
  deviceStatus: {},
  isLoading: false,
  error: null,
  setDevices: (devices: DeviceListResponseDto) => set({ devices }),
  setSelectedDevice: (serial: string | null) => set({ selectedDeviceSerial: serial }),
  setDeviceStatus: (serial: string, status: DeviceStatusResponseDto) =>
    set((state) => ({
      deviceStatus: { ...state.deviceStatus, [serial]: status },
    })),
  setLoading: (isLoading: boolean) => set({ isLoading }),
  setError: (error: string | null) => set({ error }),
}));
